export default __webpack_public_path__ + "static/media/no-release.da1eb3c3.png";